import React from 'react';
import {
  ListGroupNavItem,
  SidebarNavBack,
  SidebarNavSection,
} from './ListGroupNavComponents';

const TaskManagementNavPanel: React.FC<{ navBack: () => void }> = ({
  navBack,
}) => {
  return (
    <nav
      aria-label="secondary sidebar"
      className="second-panel tw:flex tw:flex-col tw:gap-1"
    >
      <SidebarNavBack title="Task Management" onBack={navBack} />
      <SidebarNavSection title="Critical Tasks">
        <ListGroupNavItem
          to="/task_management"
          icon="dashboard"
          label="Dashboard"
          end
        />
        <ListGroupNavItem
          to="/task_management/timeline"
          icon="timeline"
          label="Task Timeline"
        />
        <ListGroupNavItem
          to="/task_management/map"
          icon="map"
          label="Task Map"
        />
      </SidebarNavSection>
    </nav>
  );
};

export default TaskManagementNavPanel;
